import axios from "@/plugins/axios";

let url = "/api/session";

export const session = {
    get(data) {
        return axios.get(url, data).then((result) => result.data);
    },
};

export default session;
